import { api } from '../../api.ts';
import { Notice } from '../../components/Notice.tsx';
import { copy } from '../../copy/en-CA.ts';

const c = copy.admin.export;

/** One button: download everything as a JSON file, the second backup copy. */
export function AdminExportPage() {
  return (
    <>
      <div className="page-title">
        <h1>{c.title}</h1>
        <p>{c.intro}</p>
      </div>
      <section className="card stack" aria-labelledby="export-h">
        <h2 id="export-h">{c.what}</h2>
        <ul>
          {c.includes.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
        <p className="muted">{c.excludes}</p>
        <Notice kind="info">{c.sensitive}</Notice>
        <div>
          <a className="btn primary" href={api.exportUrl()} download>
            {c.download}
          </a>
        </div>
        <p className="muted small">{c.restore}</p>
      </section>
    </>
  );
}
